import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrListingReviewStatus.ts
var t = () => e("listingReviewStatus");
//#endregion
export { t as useTrListingReviewStatus };
